<div class="document" *ngIf="application && rental">

  <!-- HEADER -->
  <div class="letterhead">
    <div class="brand">
      <div class="brand-name">RCI RENTALS</div>
      <div class="brand-sub">Residential Investment & Property Management</div>
    </div>
    <div class="meta">
      <div><strong>Application Date:</strong> {{ application.createdAt?.toDate() | date }}</div>
      <div><strong>Application ID:</strong> {{ application.id }}</div>
      <div><strong>Status:</strong> {{ application.status | titlecase }}</div>
    </div>
  </div>

  <div class="divider"></div>

  <!-- PRIMARY APPLICANT -->
  <section class="section applicant-section">
    <div class="section-title">Primary Applicant</div>

    <div class="info-grid">
      <div class="info-block">
        <label>Full Name</label>
        <div>{{ application.fullName }}</div>
      </div>

      <div class="info-block">
        <label>Date of Birth</label>
        <div>{{ application.dob | date }}</div>
      </div>

      <div class="info-block">
        <label>Email</label>
        <div>{{ application.applicantEmail }}</div>
      </div>

      <div class="info-block">
        <label>Phone</label>
        <div>{{ application.phone }}</div>
      </div>

      <div class="info-block">
        <label>SSN (Last 4)</label>
        <div>{{ application.ssnLast4 || application.ssn }}</div>
      </div>

      <div class="info-block">
        <label>Driver's License</label>
        <div>{{ application.driversLicenseNum }}</div>
      </div>

      <div class="info-block full">
        <label>Current Address</label>
        <div>{{ application.currentAddress }}</div>
      </div>

      <div class="info-block">
        <label>Monthly Rent</label>
        <div>{{ application.currentRent | currency }}</div>
      </div>

      <div class="info-block">
        <label>Years at Residence</label>
        <div>{{ application.howLong }}</div>
      </div>
    </div>

    <div class="info-grid">
      <div class="info-block">
        <label>Employer</label>
        <div>{{ application.employerName }}</div>
      </div>

      <div class="info-block">
        <label>Position</label>
        <div>{{ application.jobTitle }}</div>
      </div>

      <div class="info-block">
        <label>Income</label>
        <div class="highlight">{{ application.income | currency }}</div>
      </div>

      <div class="info-block">
        <label>Years Employed</label>
        <div>{{ application.jobHowLong }}</div>
      </div>
    </div>

  </section>

  <!-- CO-APPLICANT -->
  <section class="section applicant-section" *ngIf="application.coAppFullName">
    <div class="section-title">Co-Applicant</div>

    <div class="info-grid">
      <div class="info-block">
        <label>Full Name</label>
        <div>{{ application.coAppFullName }}</div>
      </div>

      <div class="info-block">
        <label>Date of Birth</label>
        <div>{{ application.coAppDOB | date }}</div>
      </div>

      <div class="info-block">
        <label>Email</label>
        <div>{{ application.coAppEmail }}</div>
      </div>

      <div class="info-block">
        <label>Phone</label>
        <div>{{ application.coAppPhone }}</div>
      </div>

      <div class="info-block">
        <label>SSN</label>
        <div>{{ application.coAppSSN }}</div>
      </div>

      <div class="info-block">
        <label>Driver's License</label>
        <div>{{ application.coAppLicenseNum }}</div>
      </div>

      <div class="info-block full">
        <label>Current Address</label>
        <div>{{ application.coAddress }}</div>
      </div>

      <div class="info-block">
        <label>Employer</label>
        <div>{{ application.coemployerName }}</div>
      </div>

      <div class="info-block">
        <label>Position</label>
        <div>{{ application.cojobTitle }}</div>
      </div>

      <div class="info-block">
        <label>Income</label>
        <div class="highlight">{{ application.coincome | currency }}</div>
      </div>

      <div class="info-block">
        <label>Years Employed</label>
        <div>{{ application.cojobHowLong }}</div>
      </div>
    </div>
  </section>

  <!-- SHARED INFORMATION -->
  <section class="section shared-section">
    <div class="section-title">Household & Assets</div>

    <div class="info-block full">
      <label>Additional Occupants</label>
      <div>{{ application.additionalOccupants }}</div>
      <div>{{ application.occupantsDescription }}</div>
    </div>

    <div class="info-block full">
      <label>Pets</label>
      <div>{{ application.hasPets }}</div>
      <div>{{ application.petsDescription }}</div>
    </div>

    <div class="info-block full">
      <label>Vehicles</label>
      <div>
        {{ application.vehicle1Year }} {{ application.vehicle1Make }} {{ application.vehicle1Model }} ({{ application.vehicle1Plate }})<br>
        {{ application.vehicle2Year }} {{ application.vehicle2Make }} {{ application.vehicle2Model }} ({{ application.vehicle2Plate }})
      </div>
    </div>

    <div class="info-block full risk-strip">
      <div class="risk-box" [class.risk-yes]="application.evicted==='Yes'">Evicted: {{ application.evicted }}</div>
      <div [class.risk-yes]="application.evicted==='Yes'">Eviction Details: {{ application.evictionDetails }}</div>
      <div class="risk-box" [class.risk-yes]="application.convicted==='Yes'">Convicted: {{ application.convicted }}</div>
      <div [class.risk-yes]="application.crimeDetails !== 'None'">Crime Details: {{ application.crimeDetails }}</div>
      <div class="risk-box" [class.risk-yes]="application.bankruptcy==='Yes'">Bankruptcy: {{ application.bankruptcy }}</div>
      <div [class.risk-yes]="application.bankruptcyDetails !== 'None'">Bankruptcy Details: {{ application.bankruptcyDetails }}</div>
    </div>

    <div class="info-block full">
      <label>References</label>
      <div>
        {{ application.ref1name }} - {{ application.ref1Relationship }} - {{ application.ref1Phone }}<br>
        {{ application.ref2name }} - {{ application.ref2Relationship }} - {{ application.ref2Phone }}<br>
        {{ application.ref3name }} - {{ application.ref3Relationship }} - {{ application.ref3Phone }}
      </div>
    </div>
  </section>

  <!-- SIGNATURE -->
  <section class="section certification">
    <div class="section-title">Certification & Signature</div>
    <p>
      By signing below, the applicant certifies that all information provided in this application is true, complete, and accurate.
      The applicant authorizes verification of employment, income, rental history, and background information.
    </p>

    <div class="signature-grid">
      <div class="signature-block">
        <label>Applicant Signature</label>
        <div class="signature-line"></div>
        <div class="print-name">Print Name: {{ application.fullName }}</div>
      </div>

      <div class="signature-block" *ngIf="application.coAppFullName">
        <label>Co-Applicant Signature</label>
        <div class="signature-line"></div>
        <div class="print-name">Print Name: {{ application.coAppFullName }}</div>
      </div>
    </div>

    <div class="signature-date">
      Date: {{ application.signatureDate }}
    </div>
  </section>

</div>